var $ = require('jQuery');
var Component = require('../../Component');
var template = require('../../../template/notice-list.html');
var Notice = require('./Notice');
var utils = require('../../../global/utils');
var isEmpty = utils.isEmpty;

function broadCast (actionKey, value) {
  this.triggerEvent(actionKey, value);
}

var NoticeList = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
    })(this);

    (function (self) {
      self._element.click(function(e){
        var _target = $(e.target);
        var action;
        if(e.target.tagName == 'DIV'){
          if(_target.hasClass('im-notice-button')){
            action = _target.data('value') || '';
            action = action.split('@') || [];
            if(action.length == 2 && !isNaN(action[0])){
              if(self._options.noticeItems.length > Number(action[0])){
                if(self._options.noticeItems[action[0]] && typeof self._options.noticeItems[action[0]][action[1]] == 'function'){
                  self._options.noticeItems[action[0]][action[1]](e);
                }
              }
            }
          }
          else if(_target.hasClass('im-notice-close')){
            var _index = _target.data('value');
            if(!isNaN(_index)){
              self._data.notices.splice(_index, 1);
              self.triggerEvent('noticeClose', self._data.notices.length);
              self.hide();
            }
          }
        }
      });
    })(this);
};
NoticeList.prototype = Object.create(Component.prototype);
NoticeList.prototype.render = function () {
  var self = this;
  var notices = this._data.notices;
  var $element = this.getElement();
  var container = $element.find('.im-notices-container');
  var options;
  var noticeItem;
  var _broadCast = broadCast.bind(self);
  var html = [];
  container.html('');
  self._options.noticeItems = [];
  if(!isEmpty(notices) && notices.length > 0){
    self.show();
    notices.forEach(function (notice, index) {
      options = {
        broadCast: _broadCast,
        index: index
      };
      noticeItem = new Notice(options);
      noticeItem.setData({
        content: notice.text,
        qalog: notice.qaLog,
        buttons: [{action:'send', text: '发送'}, {action:'copy', text: '复制'}]
      });
      self._options.noticeItems.push(noticeItem);
      if(index == notices.length - 1)noticeItem.getElement().addClass('last-child');
      container.append(noticeItem.getElement());
    });
  }
};
NoticeList.prototype.show = function (text) {
    Component.prototype.show.call(this);
};
NoticeList.prototype.hide = function () {
    Component.prototype.hide.call(this);
};

module.exports = NoticeList;
